<ng-container *ngFor="let iconSet of formOptions.searchTerm | appIconSearch">
  <ng-container *ngIf="iconSet.icons.length > 0">
    <h2 cds-text="headline medium" class="icon-section-title clr-mt-48px">{{ iconSet.setName }}</h2>
    <div class="clr-mt-16px icon-section">
      <ng-container *ngFor="let icon of iconSet.icons">
        <button
          class="icon-section__button"
          [ngClass]="{ 'icon-section__button--selected': selectedIcon === icon[0] }"
          (click)="onIconClick(icon[0])"
        >
          <cds-icon
            cds-layout="m-l:sm m-r:sm"
            size="md"
            status="neutral"
            [shape]="icon[0]"
            [solid]="formOptions.solid"
            [badge]="formOptions.badge | appIconBadge: icon[1]"
          ></cds-icon>
          <div class="icon-section__text" cds-text="body">{{ icon[0] }}</div>
        </button>
        <div class="icon-section__detail" *ngIf="selectedIcon === icon[0]">
          <app-icon-details [iconName]="icon[0]" [iconDetails]="icon[1]" [formOptions]="formOptions"></app-icon-details>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
